import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { achievementActions } from '../actions/achievement.actions';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class AchievementEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getNextAchievement$ = createEffect(() => {
        return this.actions.pipe(
            ofType(achievementActions.getNextAchievement),
            mergeMap(() => {
                return this.httpService.getNextAchievement().pipe(
                    map((achievement) => achievementActions.getNextAchievementSuccess({ achievement })),
                    catchError(() => of(achievementActions.getNextAchievementError())),
                );
            }),
        );
    });

    getLatestAchievements$ = createEffect(() => {
        return this.actions.pipe(
            ofType(achievementActions.getLatestAchievements),
            mergeMap(() => {
                return this.httpService.getLatestAchievements().pipe(
                    map((achievements) => achievementActions.getLatestAchievementsSuccess({ achievements })),
                    catchError(() => of(achievementActions.getLatestAchievementsError())),
                );
            }),
        );
    });
}
